import { Component , OnInit} from '@angular/core';
// mospina 10-10-16 EPT-2380 Cambio general identidad AVATAR
import { ThemeService } from './core/services/theme.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit  {

  // mospina 10-10-16 EPT-2380 Cambio general identidad AVATAR
  constructor(private theme: ThemeService) { }

  ngOnInit() {
    // mospina 10-10-16 EPT-2380 Cambio general identidad AVATAR
    // Reaplica el tema de colores guardado en el último login (al recargar la página)
    this.theme.restaurar();
    // document.getElementsByTagName("html")[0].setAttribute("dir", "rtl");
  }
}
